/* Custom Pet Shop – Product Studio (pillows, blankets, mugs, socks, apparel, ...) */
(function () {
  'use strict';
  function init(root) {
    if (root.__cst) return; root.__cst = true;
    var $ = function (s, el) { return (el || root).querySelector(s); };
    var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
    var data; try { data = JSON.parse($('[data-cst-data]').textContent); } catch (e) { console.error('[cst] data', e); return; }
    var styles = data.styles || []; if (!styles.length) return;
    var cur = root.getAttribute('data-currency') || 'USD';
    var money = function (c) {
      try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(c / 100).replace(/\.00$/, ''); }
      catch (e) { return '$' + (c / 100).toFixed(0); }
    };
    var qs = new URLSearchParams(location.search);
    var store = { get: function () { try { return JSON.parse(sessionStorage.getItem('cst') || '{}'); } catch (e) { return {}; } },
                  set: function (o) { try { sessionStorage.setItem('cst', JSON.stringify(o)); } catch (e) {} } };
    var saved = store.get();
    var MINPX = +root.getAttribute('data-minpx') || 800;
    var NOUN = root.getAttribute('data-noun') || 'pillow', NOUNS = root.getAttribute('data-nouns') || (NOUN + 's');

    var el = {
      form: $('[data-cst-form]'), track: $('[data-cst-track]'), dots: $('[data-cst-dots]'), cap: $('[data-cst-cap]'), count: $('[data-cst-count]'),
      sizes: $('[data-cst-sizes]'), sizeHint: $('[data-cst-sizehint]'), t1: $('[data-cst-t1]'), t2: $('[data-cst-t2]'), textLabel: $('[data-cst-textlabel]'),
      sidePrice: $('[data-cst-sideprice]'), price: $('[data-cst-price]'), was: $('[data-cst-was]'), save: $('[data-cst-save]'), sum: $('[data-cst-sum]'),
      eta: $('[data-cst-eta]'), cta: $('[data-cst-cta]'), err: $('[data-cst-err]'), bar: $('[data-cst-bar]'), progress: $('[data-cst-progress]'),
      later: $('[data-cst-later]'), gift: $('[data-cst-gift]'), giftMsg: $('[data-cst-giftmsg]'), note: $('[data-cst-note]'), photoLabel: $('[data-cst-photolabel]'),
      sticky: $('[data-cst-sticky]'), sTitle: $('[data-cst-stitle]'), sPrice: $('[data-cst-sprice]'), sBtn: $('[data-cst-sbtn]'), buy: $('[data-cst-buy]'),
      chart: $('[data-cst-chart]'), chartTable: $('[data-cst-chart-table]'), chartSub: $('[data-cst-chart-sub]')
    };
    var step = function (name) { return $('[data-step="' + name + '"]'); };
    // Shopify express checkout (cart wallets) shown under Add to cart once the design is complete
    var wal = $('[data-cst-wallets]'), walNote = $('[data-cst-wnote]'), sync = null;

    // ---------- state
    var findStyle = function (v) {
      v = (v || '').toLowerCase();
      return styles.filter(function (s) { return s.id === v || s.alias === v || (s.label || '').toLowerCase() === v; })[0];
    };
    var petQ = (qs.get('pet') || '').toLowerCase();
    var state = {
      pet: petQ === 'cat' || petQ === 'dog' ? petQ : (saved.pet || 'dog'),
      style: findStyle(qs.get('style')) || findStyle(saved.style) || styles[0],
      sel: null, side: 'front', qty: 1, photos: {}, dims: {}
    };
    var wantSize = (qs.get('size') || saved.size || '').toUpperCase();
    // product view for the current style + pet (filters variants by the style's "Style" option value)
    var viewCache = {};
    var prod = function () {
      var raw = state.style.pets[state.pet] || state.style.pets.dog || state.style.pets.cat;
      var key = state.style.id + '|' + raw.handle;
      if (viewCache[key]) return viewCache[key];
      var names = raw.optionNames || ['Size'];
      var si = -1, sv = (state.style.styleValue || '').toLowerCase();
      if (sv) names.forEach(function (n, i) { if (/^style$/i.test(n)) si = i; });
      var vs = raw.variants.filter(function (v) { return si < 0 || (v.options[si] || '').toLowerCase() === sv; });
      if (!vs.length) { vs = raw.variants; si = -1; }
      var view = { handle: raw.handle, title: raw.title, images: raw.images,
        optionNames: names.filter(function (n, i) { return i !== si; }),
        variants: vs.map(function (v) { return { id: v.id, price: v.price, cmp: v.cmp, available: v.available, options: v.options.filter(function (o, i) { return i !== si; }) }; }) };
      if (!view.optionNames.length) { view.optionNames = ['Option']; view.variants.forEach(function (v) { v.options = ['Default']; }); }
      view.sizeIdx = 0; view.optionNames.forEach(function (n, i) { if (/size|dimension|model/i.test(n)) view.sizeIdx = i; });
      if (view.optionNames.length > 1 && !/size|dimension|model/i.test(view.optionNames[view.sizeIdx])) view.sizeIdx = view.optionNames.length - 1;
      viewCache[key] = view; return view;
    };
    var match = function (sel) { return prod().variants.filter(function (v) { return v.options.every(function (o, k) { return o === sel[k]; }); })[0]; };
    var variant = function () { var p = prod(); return (state.sel && match(state.sel)) || p.variants[0]; };

    // ---------- size labels
    var parseSize = function (val) {
      val = String(val || '');
      var o = { code: '', main: val, sub: '', pop: /most popular|best seller/i.test(val), inch: 0 };
      var clean = val.replace(/\s*\((most popular|best seller)\)\s*/i, ' ').trim();
      var m = clean.match(/\(([A-Z0-9]{1,4})\)\s*:\s*([\d.]+)"\s*\(?\s*(\d+\s*cm)?/i);
      if (m) { o.code = m[1].toUpperCase(); o.main = m[2] + '"'; o.sub = m[3] ? m[3].replace(/\s+/g, ' ') : Math.round(+m[2] * 2.54) + ' cm'; o.inch = +m[2]; return o; }
      m = clean.match(/([\d.]+)\s*(?:"|in)?\s*[x×]\s*([\d.]+)\s*(cm|in|")?/i);
      if (m) {
        if (/cm/i.test(clean)) { o.main = Math.round(m[1] / 2.54) + '" × ' + Math.round(m[2] / 2.54) + '"'; o.sub = m[1] + ' × ' + m[2] + ' cm'; o.inch = m[1] / 2.54; } // US shoppers: inches first
        else { o.main = m[1] + '" × ' + m[2] + '"'; o.sub = Math.round(m[1] * 2.54) + ' × ' + Math.round(m[2] * 2.54) + ' cm'; o.inch = +m[1]; }
        if (NOUN === 'blanket') { var wi = Math.round(o.inch); if (wi === 50) o.pop = true; if (wi === 60) o.best = true; } // blanket tags: Medium = Most popular, Large = Best value
        return o;
      }
      m = clean.match(/^([\d.]+)\s*(oz|in|"|cm)$/i);
      if (m) { var u = m[2].toLowerCase(); o.main = m[1] + (u === 'in' || u === '"' ? '"' : ' ' + u); if (u === 'in' || u === '"') { o.inch = +m[1]; o.sub = Math.round(m[1] * 2.54) + ' cm'; } if (u === 'oz') o.sub = Math.round(m[1] * 29.57) + ' ml'; return o; }
      o.main = clean;
      return o;
    };
    var sizeWord = function (inch, shape) {
      if (inch && NOUN === 'blanket') return inch <= 35 ? 'Small · lap & pet bed size' : inch <= 55 ? 'Medium · couch throw, our most popular size' : 'Large · covers a bed, best value per inch';
      if (!inch || NOUN !== 'pillow') return '';
      if (shape === 'square') return inch <= 14 ? 'Accent cushion for chairs and beds' : inch <= 16 ? 'Classic sofa cushion, our best seller' : inch <= 18 ? 'Big sofa cushion' : 'Statement cushion, extra huggable';
      return inch <= 10 ? 'Mini keepsake for a shelf or desk' : inch <= 12 ? 'Desk, car or nursery size' : inch <= 16 ? 'Lap-sized, great for gifting' : inch <= 20 ? 'Sofa favourite, close to life-size for small pets' : inch <= 24 ? 'Big hug size, life-size for many cats and small dogs' : 'Extra large, life-size for medium to big dogs';
    };

    // ---------- gallery
    var gIdx = 0, slides = [];
    var buildGallery = function () {
      var p = prod(); var imgs = (p.images || []).filter(Boolean);
      slides = [];
      var firstPhoto = state.photos[1];
      if (firstPhoto && firstPhoto !== 'file') slides.push({ preview: true, src: firstPhoto });
      imgs.forEach(function (s) { slides.push({ src: s }); });
      el.track.innerHTML = '';
      el.dots.innerHTML = '';
      slides.forEach(function (s, i) {
        var d = document.createElement('div'); d.className = 'cst-slide' + (s.preview ? ' cst-slide--preview' : '');
        if (s.preview) {
          var frame = document.createElement('div'); frame.className = 'cst-mock cst-mock--' + state.style.shape;
          var im = document.createElement('img'); im.src = s.src; im.alt = 'Your pet'; frame.appendChild(im);
          var tx = document.createElement('span'); tx.className = 'cst-mock__text'; tx.setAttribute('data-cst-mocktext', ''); frame.appendChild(tx);
          d.appendChild(frame);
          var tag = document.createElement('span'); tag.className = 'cst-slide__tag'; tag.textContent = 'Your ' + NOUN + ' · quick preview'; d.appendChild(tag);
        } else {
          var img = document.createElement('img'); img.src = s.src; img.alt = state.style.label + ' ' + NOUN + ' example ' + (i + 1); img.loading = i ? 'lazy' : 'eager';
          if (!i) img.fetchPriority = 'high';
          img.width = 900; img.height = 900; d.appendChild(img);
        }
        el.track.appendChild(d);
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (i + 1));
        b.addEventListener('click', function () { go(i); }); el.dots.appendChild(b);
      });
      gIdx = 0; el.track.scrollLeft = 0; markDot(); renderMockText();
    };
    var go = function (i) { i = Math.max(0, Math.min(slides.length - 1, i)); el.track.scrollTo({ left: i * el.track.clientWidth, behavior: 'smooth' }); };
    var markDot = function () {
      $$('button', el.dots).forEach(function (b, i) { b.classList.toggle('is-on', i === gIdx); });
      if (el.count) el.count.textContent = slides.length ? (gIdx + 1) + ' / ' + slides.length : '';
      var s = slides[gIdx];
      el.cap.textContent = s && s.preview ? 'Quick preview. Our designer perfects it and emails you the real design to approve.' : state.style.label + ' · ' + (state.pet === 'cat' ? 'Cat' : 'Dog');
    };
    var st; el.track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var w = el.track.clientWidth || 1; gIdx = Math.round(el.track.scrollLeft / w); markDot(); }, 60); }, { passive: true });
    $('[data-cst-prev]').addEventListener('click', function () { go(gIdx - 1); });
    $('[data-cst-next]').addEventListener('click', function () { go(gIdx + 1); });
    el.track.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') go(gIdx + 1); if (e.key === 'ArrowLeft') go(gIdx - 1); });
    var renderMockText = function () {
      var t = $('[data-cst-mocktext]'); if (!t) return;
      var on = state.style.text !== 'none';
      var txt = on ? [el.t1.value.trim(), el.t2.value.trim()].filter(Boolean).join(' · ') : '';
      t.textContent = txt; t.hidden = !txt;
    };

    // ---------- sizes & options
    var printIdx = function () { var n = prod().optionNames || []; for (var i = 0; i < n.length; i++) { if (/^print/i.test(n[i])) return i; } return -1; };
    var printVal = function () { return state.side === 'both' ? 'Both sides' : 'Front only'; };
    var buildSizes = function () {
      var p = prod(), vs = p.variants, names = p.optionNames, SI = p.sizeIdx, PI = printIdx();
      var single = vs.length === 1 && /^default/i.test(vs[0].options.join(''));
      step('size').hidden = single;
      if (single) { state.sel = vs[0].options.slice(); el.sizes.innerHTML = ''; return; }
      var prev = state.sel, prevInch = null;
      if (prev && state.prevNames) { var pi = state.prevSizeIdx; if (prev[pi] != null) prevInch = parseSize(prev[pi]).inch; }
      var pick = null;
      var avail = vs.filter(function (v) { return v.available; }); if (!avail.length) avail = vs;
      if (PI > -1) { var av2 = avail.filter(function (v) { return v.options[PI] === printVal(); }); if (av2.length) avail = av2; }
      if (wantSize) { avail.forEach(function (v) { var z = parseSize(v.options[SI]); if (!pick && (z.code === wantSize || String(z.inch) === wantSize || v.options[SI].toUpperCase() === wantSize)) pick = v; }); wantSize = ''; }
      if (!pick && prev && state.prevNames && state.prevNames.join() === names.join()) pick = match(prev);
      if (!pick && prevInch) { var best = 1e9; avail.forEach(function (v) { var d = Math.abs(parseSize(v.options[SI]).inch - prevInch); if (d < best) { best = d; pick = v; } }); }
      if (!pick) avail.forEach(function (v) { if (!pick && v.options.some(function (o) { return parseSize(o).pop; })) pick = v; });
      if (!pick) pick = avail[0];
      if (PI > -1 && pick.options[PI] !== printVal()) { var t2 = pick.options.slice(); t2[PI] = printVal(); pick = match(t2) || pick; }
      state.sel = pick.options.slice(); state.prevNames = names.slice(); state.prevSizeIdx = SI;
      el.sizes.innerHTML = '';
      var sl = $('[data-cst-sizelabel]');
      if (sl) sl.textContent = names.filter(function (n, k) { if (k === PI) return false; var u = {}; vs.forEach(function (v) { u[v.options[k]] = 1; }); return Object.keys(u).length > 1; }).join(' & ') || names[SI];
      names.forEach(function (name, k) {
        if (k === PI) return;
        var values = []; vs.forEach(function (v) { if (values.indexOf(v.options[k]) < 0) values.push(v.options[k]); });
        if (values.length < 2 && names.length > 1) return;
        var isSize = k === SI;
        var group = document.createElement('div'); group.className = 'cst-optgroup' + (isSize ? ' is-size' : '');
        if (names.length > 1 && !isSize) { var lb = document.createElement('p'); lb.className = 'cst-optlbl'; lb.textContent = name; group.appendChild(lb); }
        if (values.length > 6 && !values.some(function (x) { return parseSize(x).code; })) {
          var selEl = document.createElement('select'); selEl.className = 'cst-input cst-select'; selEl.setAttribute('data-k', k); selEl.setAttribute('aria-label', name);
          values.forEach(function (val) { var op = document.createElement('option'); op.value = val; op.textContent = parseSize(val).main; selEl.appendChild(op); });
          selEl.value = state.sel[k];
          selEl.addEventListener('change', function () { choose(k, selEl.value); });
          group.appendChild(selEl);
        } else {
          var grid = document.createElement('div'); grid.className = isSize ? 'cst-sizes' : 'cst-chips2'; grid.setAttribute('role', 'radiogroup'); grid.setAttribute('aria-label', name);
          grid.style.setProperty('--n', Math.min(values.length, 5));
          values.forEach(function (val) {
            var z = parseSize(val);
            var lab = document.createElement('label'); lab.className = isSize ? 'cst-size' : 'cst-chip2';
            var inp = document.createElement('input'); inp.type = 'radio'; inp.name = 'cst-o' + k + '-' + root.id; inp.value = val; inp.setAttribute('data-k', k);
            var span = document.createElement('span');
            if (isSize) {
              if (z.pop) { var pp = document.createElement('em'); pp.textContent = NOUN === 'blanket' ? 'Most popular' : 'Popular'; span.appendChild(pp); }
              else if (z.best) { var bv = document.createElement('em'); bv.textContent = 'Best value'; span.appendChild(bv); }
              if (z.code) { var c = document.createElement('b'); c.textContent = z.code; span.appendChild(c); var mn = document.createElement('strong'); mn.textContent = z.main; span.appendChild(mn); }
              else { var c2 = document.createElement('b'); c2.textContent = z.main; span.appendChild(c2); }
            } else { var t = document.createElement('b'); t.textContent = z.main; span.appendChild(t); }
            var pr = document.createElement('small'); pr.setAttribute('data-cst-optprice', ''); span.appendChild(pr);
            lab.appendChild(inp); lab.appendChild(span); grid.appendChild(lab);
            inp.addEventListener('change', function () { choose(k, val); });
          });
          group.appendChild(grid);
        }
        el.sizes.appendChild(group);
      });
      syncOptions();
    };
    var choose = function (k, val) {
      var sel = state.sel.slice(); sel[k] = val;
      var m = match(sel);
      if (!m || !m.available) m = prod().variants.filter(function (v) { return v.options[k] === val && v.available; })[0] || m;
      if (m) state.sel = m.options.slice();
      track('option'); syncOptions(); render();
    };
    var syncOptions = function () {
      var cur = variant();
      $$('input[data-k]', el.sizes).forEach(function (i) {
        var k = +i.getAttribute('data-k'); i.checked = state.sel[k] === i.value;
        var test = state.sel.slice(); test[k] = i.value; var m = match(test);
        i.disabled = !m || !m.available;
        var sm = i.parentNode.querySelector('[data-cst-optprice]'); if (!sm) return;
        if (k === prod().sizeIdx) sm.textContent = m ? money(m.price) : '';
        else sm.textContent = m && m.price !== cur.price ? (m.price > cur.price ? '+' : '−') + money(Math.abs(m.price - cur.price)) : '';
      });
      $$('select[data-k]', el.sizes).forEach(function (s2) { s2.value = state.sel[+s2.getAttribute('data-k')]; });
      buildChart();
    };
    var buildChart = function () {
      var p = prod(), SI = p.sizeIdx;
      el.chartSub.textContent = p.title;
      var seen = {}, rows = '<thead><tr><th>Size</th><th>Measurements</th><th>Price</th></tr></thead><tbody>';
      p.variants.forEach(function (v) {
        var same = v.options.every(function (o, k) { return k === SI || o === state.sel[k]; }); if (!same) return;
        var val = v.options[SI]; if (seen[val]) return; seen[val] = 1;
        var z = parseSize(val);
        var dims = z.code ? z.main + (z.sub ? ' · ' + z.sub : '') : (z.sub ? z.main + ' · ' + z.sub : '—');
        rows += '<tr><td><b>' + (z.code || z.main) + '</b>' + (z.pop ? ' <small>' + (NOUN === 'blanket' ? 'Most popular' : 'Popular') + '</small>' : (z.best ? ' <small>Best value</small>' : '')) + '</td><td>' + dims + '</td><td>' + money(v.price) + '</td></tr>';
      });
      el.chartTable.innerHTML = rows + '</tbody>';
      var note = $('[data-cst-chart-note]');
      if (note) note.textContent = state.style.chartNote || (state.style.shape === 'square' && NOUN === 'pillow' ? 'Measured edge to edge. The cushion insert is included.' : state.style.shape === 'shaped' ? "Measured at the longest side. Pet-shaped pillows follow your pet's outline, so the other side depends on the pose." : 'Measured at the widest point.');
      var open = $('[data-cst-chart-open]'); if (open) open.hidden = !Object.keys(seen).some(function (k) { var z = parseSize(k); return z.sub || z.code; });
    };

    // ---------- style / pet application
    var applyStyle = function () {
      var s = state.style;
      styles.forEach(function (x) {
        var keep = state.style; state.style = x; var q = prod(); state.style = keep; if (!q) return;
        var fr = $('[data-cst-from="' + x.id + '"]'); if (fr) fr.textContent = 'From ' + money(Math.min.apply(null, q.variants.map(function (v) { return v.price; })));
      });
      $$('input[name="cst-style"]').forEach(function (r) { r.checked = r.value === s.id; });
      step('text').hidden = s.text === 'none';
      el.textLabel.textContent = s.textLabel || 'Name on the ' + NOUN;
      el.t2.placeholder = s.t2 || 'Optional second line';
      el.t1.required = s.text === 'required';
      var canSides = s.sides && (printIdx() > -1 || data.addonSides);
      step('sides').hidden = !canSides;
      if (!canSides) { state.side = 'front'; var f = $('input[name="cst-side"][value="front"]'); if (f) f.checked = true; }
      buildSizes(); buildGallery(); render();
    };
    var setPetWords = function () {
      var w = state.pet === 'cat' ? 'cat' : 'dog';
      $$('input[name="cst-pet"]').forEach(function (r) { r.checked = r.value === state.pet; });
      el.photoLabel.textContent = state.qty > 1 ? 'Your pets\' photos' : 'Your ' + w + '\'s photo';
      $$('[data-cst-pname]').forEach(function (i) { i.placeholder = (w === 'cat' ? 'Cat' : 'Dog') + '\'s name (optional)'; });
      el.t1.placeholder = (w === 'cat' ? 'Cat' : 'Dog') + '\'s name, e.g. ' + (w === 'cat' ? 'Luna' : 'Biscuit');
    };
    $$('input[name="cst-pet"]').forEach(function (r) { r.addEventListener('change', function () { if (!r.checked) return; state.pet = r.value; setPetWords(); track('pet'); applyStyle(); }); });
    $$('input[name="cst-style"]').forEach(function (r) { r.addEventListener('change', function () { if (!r.checked) return; state.style = findStyle(r.value); track('style'); applyStyle(); }); });
    $$('input[name="cst-side"]').forEach(function (r) { r.addEventListener('change', function () { if (!r.checked) return; state.side = r.value; var PI = printIdx(); if (PI > -1) choose(PI, printVal()); else render(); }); });
    $$('input[name="cst-qty"]').forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return; state.qty = +r.value;
        $$('[data-cst-up]').forEach(function (u) { u.hidden = +u.getAttribute('data-cst-up') > state.qty; });
        if (state.qty > 1) root.setAttribute('data-multi', ''); else root.removeAttribute('data-multi');
        setPetWords(); track('qty'); render();
      });
    });
    [el.t1, el.t2].forEach(function (i) { i.addEventListener('input', function () { renderMockText(); render(); }); });
    if (el.gift) el.gift.addEventListener('change', function () { el.giftMsg.hidden = !el.gift.checked; if (el.gift.checked) el.giftMsg.focus(); });
    if (el.later) el.later.addEventListener('change', function () { root.classList.toggle('is-later', el.later.checked); el.err.textContent = ''; render(); });

    // ---------- photos
    var MAX = 20 * 1024 * 1024;
    $$('[data-cst-up]').forEach(function (box) {
      var n = +box.getAttribute('data-cst-up');
      var input = $('[data-cst-file]', box), drop = $('[data-cst-drop]', box), qc = $('[data-cst-qc]', box);
      var onFile = function () {
        var f = input.files && input.files[0]; el.err.textContent = ''; qc.className = 'cst-qc'; qc.textContent = '';
        if (!f) return;
        if (f.type && !/^image\//.test(f.type) && !/\.(heic|heif)$/i.test(f.name)) { input.value = ''; qc.className = 'cst-qc is-bad'; qc.textContent = 'Please choose a photo file.'; return; }
        var url = URL.createObjectURL(f);
        state.upl = state.upl || {}; state.upl[n] = f.size <= MAX ? f : null;
        box.classList.add('is-done');
        $('[data-cst-uptitle]', box).textContent = 'Photo added ✓';
        $('[data-cst-upsub]', box).textContent = (f.name.length > 28 ? f.name.slice(0, 25) + '…' : f.name) + ' · tap to change';
        var th = $('[data-cst-upthumb]', box);
        var test = new Image();
        test.onload = function () {
          th.innerHTML = ''; var i = document.createElement('img'); i.src = url; i.alt = ''; th.appendChild(i);
          var mn = Math.min(test.naturalWidth, test.naturalHeight);
          state.dims[n] = test.naturalWidth + 'x' + test.naturalHeight;
          var big = Math.max(test.naturalWidth, test.naturalHeight), sc = Math.min(1, 3200 / big);
          if (f.size > 6 * 1024 * 1024 || sc < 1) {
            state.shr = state.shr || {}; state.shr[n] = true;
            try {
              var cv = document.createElement('canvas'); cv.width = Math.round(test.naturalWidth * sc); cv.height = Math.round(test.naturalHeight * sc);
              cv.getContext('2d').drawImage(test, 0, 0, cv.width, cv.height);
              cv.toBlob(function (b) { if (b) state.upl[n] = new File([b], (f.name || 'photo').replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }); state.shr[n] = false; render(); }, 'image/jpeg', 0.9);
            } catch (er) { state.shr[n] = false; }
          }
          if (mn >= MINPX) { qc.className = 'cst-qc is-ok'; qc.textContent = 'Great photo ✓ Sharp enough for a crisp print.'; }
          else { qc.className = 'cst-qc is-warn'; qc.textContent = 'This photo is a bit small and may print soft. Try the original from your camera roll, or keep it and our designer will do their best.'; }
          state.photos[n] = url;
          if (n === 1) { buildGallery(); }
          render();
        };
        test.onerror = function () {
          th.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12l5 5 9-10" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          if (f.size > MAX) {
            state.upl[n] = null; input.value = ''; box.classList.remove('is-done');
            $('[data-cst-uptitle]', box).textContent = 'Upload photo';
            if (el.later) { el.later.checked = true; root.classList.add('is-later'); }
            qc.className = 'cst-qc is-ok'; qc.textContent = 'This photo is too large to upload here. No problem: just reply to your order email with it and we\'ll take it from there.';
            render(); return;
          }
          qc.className = 'cst-qc is-ok'; qc.textContent = 'Photo received. Our designer will check it for you.';
          state.photos[n] = 'file'; render();
        };
        test.src = url;
        track('photo');
      };
      input.addEventListener('change', onFile);
      ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
      drop.addEventListener('drop', function (e) {
        var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]; if (!f) return;
        try { var dt = new DataTransfer(); dt.items.add(f); input.files = dt.files; } catch (er) {}
        onFile();
      });
    });
    var missingPhotos = function () {
      if (el.later && el.later.checked) return [];
      return $$('[data-cst-up]').filter(function (u) { return !u.hidden && !($('[data-cst-file]', u).files || []).length; });
    };

    // ---------- delivery (counts Mon–Sat)
    var addBiz = function (n) { var d = new Date(), a = 0; while (a < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) a++; } return d; };
    var fmt = function (d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };

    // ---------- render
    var visibleSteps = function () { return $$('.cst-step').filter(function (s) { return !s.hidden; }); };
    var render = function () {
      var v = variant(), s = state.style, PI = printIdx();
      if (el.sidePrice) {
        if (PI > -1) { var t3 = v.options.slice(); t3[PI] = 'Both sides'; var mb = match(t3); t3[PI] = 'Front only'; var mf = match(t3); el.sidePrice.textContent = mb && mf && mb.price > mf.price ? '+' + money(mb.price - mf.price) : ''; }
        else if (data.addonSides) el.sidePrice.textContent = '+' + money(data.addonSides.price);
      }
      var unit = v.price + (state.side === 'both' && data.addonSides && PI < 0 ? data.addonSides.price : 0);
      var full = unit * state.qty;
      var free = state.qty >= 3 ? unit * Math.floor(state.qty / 3) : 0;
      var pay = full - free;
      var cmpUnit = v.cmp && v.cmp > v.price ? v.cmp + (unit - v.price) : 0;
      var was = Math.max(cmpUnit * state.qty, free ? full : 0);
      el.price.textContent = money(pay);
      var plbl = $('.cst-price__lbl'); if (plbl) plbl.textContent = state.qty > 1 ? state.qty + ' ' + NOUNS : 'Your ' + NOUN;
      el.was.textContent = was > pay ? money(was) : '';
      el.save.hidden = !(was > pay); el.save.textContent = was > pay ? 'You save ' + money(was - pay) : '';
      $$('[data-cst-qn]').forEach(function (b2) { var n2 = +b2.getAttribute('data-cst-qn'); b2.textContent = n2 + ' ' + (n2 > 1 ? NOUNS : NOUN); });
      $$('[data-cst-qp]').forEach(function (q) {
        var n = +q.getAttribute('data-cst-qp'); var t = unit * n - (n >= 3 ? unit : 0);
        q.innerHTML = n >= 3 ? '<s>' + money(unit * n) + '</s> ' + money(t) : money(t);
      });
      var SI = prod().sizeIdx, sz = parseSize(v.options[SI]);
      var bits = [s.label].concat(v.options.filter(function (o, k) { return k !== PI && !/^default/i.test(o); }).map(function (o) { var z = parseSize(o); return (z.code ? z.code + ' ' : '') + z.main; }), [state.pet === 'cat' ? 'Cat' : 'Dog']);
      if (!step('sides').hidden) bits.push(state.side === 'both' ? 'Both sides' : 'Front only');
      if (s.text !== 'none' && el.t1.value.trim()) bits.push('“' + el.t1.value.trim() + '”');
      if (state.qty > 1) bits.push(state.qty + ' ' + NOUNS);
      el.sum.innerHTML = ''; bits.forEach(function (b) { var x = document.createElement('span'); x.textContent = b; el.sum.appendChild(x); });
      el.sizeHint.textContent = sizeWord(sz.inch, s.shape);
      var extra = state.side === 'both' ? (+root.getAttribute('data-dboth') || 0) : 0;
      el.eta.textContent = 'Order today, estimated delivery ' + fmt(addBiz((+root.getAttribute('data-dmin') || 4) + extra)) + ' – ' + fmt(addBiz((+root.getAttribute('data-dmax') || 8) + extra));
      var vis = visibleSteps(), done = 0;
      vis.forEach(function (fs, i) {
        var n = $('[data-n]', fs); if (n) n.textContent = i + 1;
        var name = fs.getAttribute('data-step'), ok = true;
        if (name === 'photo') ok = !missingPhotos().length;
        if (name === 'text') ok = s.text !== 'required' || !!el.t1.value.trim();
        fs.classList.toggle('is-done', ok);
        if (ok) done++;
      });
      el.bar.style.width = Math.round(100 * done / vis.length) + '%';
      var need = missingPhotos().length;
      el.progress.textContent = need ? (done + ' of ' + vis.length + ' done · add your photo to finish') : 'All set. Review and add to cart';
      var label = v.available ? (need ? 'Upload photo' : 'Add to cart') : 'Sold out';
      el.cta.textContent = label; el.cta.disabled = !v.available;
      el.cta.classList.toggle('is-muted', !!need);
      el.sTitle.textContent = s.label + (!/^default/i.test(sz.main) ? ' · ' + (sz.code || sz.main) : '');
      el.sPrice.textContent = money(pay);
      el.sBtn.textContent = need ? 'Upload photo' : 'Add to cart';
      store.set({ pet: state.pet, style: s.alias, size: sz.code || String(sz.inch || '') });
      scheduleSync(120);
    };

    // ---------- sticky bar
    if ('IntersectionObserver' in window) {
      var buyVis = false, topVis = true;
      var upd = function () { var show = !buyVis && !topVis; el.sticky.classList.toggle('show', show); el.sticky.setAttribute('aria-hidden', show ? 'false' : 'true'); el.sBtn.tabIndex = show ? 0 : -1; };
      new IntersectionObserver(function (es) { es.forEach(function (e) { buyVis = e.isIntersecting; }); upd(); }, { threshold: 0.15 }).observe(el.buy);
      new IntersectionObserver(function (es) { es.forEach(function (e) { topVis = e.isIntersecting; }); upd(); }, { threshold: 0 }).observe($('.cst-head'));
    }
    el.sBtn.addEventListener('click', function () {
      var m = missingPhotos();
      var t = m.length ? m[0] : el.buy;
      t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (m.length) setTimeout(function () { $('[data-cst-file]', m[0]).click(); }, 450);
    });

    // ---------- size chart
    $('[data-cst-chart-open]').addEventListener('click', function () { if (el.chart.showModal) el.chart.showModal(); else el.chart.setAttribute('open', ''); });
    $('[data-cst-chart-close]').addEventListener('click', function () { if (el.chart.close) el.chart.close(); else el.chart.removeAttribute('open'); });
    el.chart.addEventListener('click', function (e) { if (e.target === el.chart && el.chart.close) el.chart.close(); });

    // ---------- analytics hook
    var track = function (name) {
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ event: 'cst_' + name, cst_style: state.style.alias, cst_pet: state.pet }); } catch (e) {}
    };

    // ---------- add to cart
    var root_url = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    // build one cart line per pet; photos already saved to the cart are reused by link (no second upload)
    var photoFile = function (i) {
      var upf = state.upl && state.upl[i]; if (upf) return upf;
      var fi = $('[data-cst-up="' + i + '"] [data-cst-file]');
      return fi && fi.files && fi.files[0] && fi.files[0].size <= MAX ? fi.files[0] : null;
    };
    var buildJobs = function (key) {
      var s = state.style, v = variant(), jobs = [];
      var text = s.text !== 'none' ? [el.t1.value.trim(), el.t2.value.trim()].filter(Boolean).join(' / ') : '';
      for (var i = 1; i <= state.qty; i++) {
        var fd = new FormData();
        fd.append('id', v.id); fd.append('quantity', '1');
        fd.append('properties[Pet]', state.pet === 'cat' ? 'Cat' : 'Dog');
        var pn = $('[data-cst-up="' + i + '"] [data-cst-pname]'); if (pn && pn.value.trim()) fd.append('properties[Pet name]', pn.value.trim().slice(0, 30));
        if (text) fd.append('properties[Text on ' + NOUN + ']', text);
        if (!step('sides').hidden) fd.append('properties[Print]', state.side === 'both' ? 'Both sides' : 'Front only');
        if (s.occasion) fd.append('properties[Occasion]', s.occasion);
        var pf = photoFile(i), saved = sync && sync.urls[i];
        fd.__i = i; fd.__f = pf;
        if (pf && saved && saved.f === pf) fd.append('properties[Photo]', saved.u);
        else if (pf) { fd.append('properties[Photo]', pf, pf.name || 'photo.jpg'); fd.__up = true; }
        else fd.append('properties[Photo]', 'Will email after ordering');
        if (el.gift && el.gift.checked) fd.append('properties[Gift note]', (el.giftMsg.value || 'Yes, this is a gift').trim().slice(0, 200));
        if (el.note && el.note.value.trim()) fd.append('properties[Note for designer]', el.note.value.trim().slice(0, 300));
        if (state.qty > 1) fd.append('properties[Item]', i + ' of ' + state.qty);
        fd.append('properties[_build]', key + '-' + i);
        jobs.push(fd);
      }
      return jobs;
    };
    var sigOf = function () {
      var out = [state.side, state.qty];
      buildJobs('x').forEach(function (fd) {
        out.push(fd.__f ? (fd.__f.name + ':' + fd.__f.size + ':' + fd.__f.lastModified) : '-');
        fd.forEach(function (val, k) { if (k !== 'properties[_build]' && k !== 'properties[Photo]') out.push(k + '=' + val); });
      });
      return out.join('|');
    };
    var postJSON = function (url, body) {
      return fetch(root_url + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not update cart.'); return j; }); });
    };
    var addLine = function (fd, onp) {
      return new Promise(function (res, rej) {
        var x = new XMLHttpRequest();
        x.open('POST', root_url + 'cart/add.js'); x.setRequestHeader('Accept', 'application/json');
        if (onp && fd.__up && x.upload) x.upload.onprogress = function (e) { if (e.lengthComputable) onp(Math.min(99, Math.round(e.loaded / e.total * 100))); };
        x.onload = function () { var j = {}; try { j = JSON.parse(x.responseText); } catch (er) {} if (x.status >= 200 && x.status < 300) res(j); else rej(new Error(j.description || j.message || 'Could not add to cart.')); };
        x.onerror = function () { rej(new Error('Upload interrupted. Check your connection.')); };
        x.send(fd);
      });
    };
    // replace whatever this page added before with the current design; returns a promise
    var putInCart = function (onUpload) {
      var key = 'cst' + Date.now().toString(36), jobs = buildJobs(key), want = sigOf(), keys = [];
      if (onUpload && jobs.some(function (fd) { return fd.__up; })) onUpload(0);
      var old = {}; sync.keys.forEach(function (k) { old[k] = 0; });
      var chain = sync.keys.length ? postJSON('cart/update.js', { updates: old }).catch(function () {}) : Promise.resolve();
      chain = chain.then(function () { sync.keys = []; sync.sig = null; });
      jobs.forEach(function (fd) {
        chain = chain.then(function () { return addLine(fd, onUpload); }).then(function (it) {
          keys.push(it.key);
          var u = it.properties && it.properties.Photo;
          if (fd.__f && typeof u === 'string' && /^(https?:)?\/\//.test(u)) sync.urls[fd.__i] = { f: fd.__f, u: u };
        });
      });
      return chain.then(function () {
        if (state.side === 'both' && !step('sides').hidden && data.addonSides && printIdx() < 0) {
          return postJSON('cart/add.js', { items: [{ id: data.addonSides.id, quantity: state.qty, properties: { _build: key, For: state.style.label + ' ' + NOUN } }] })
            .then(function (j) { (j.items || []).forEach(function (x) { keys.push(x.key); }); });
        }
      }).then(function () { sync.keys = keys; sync.sig = want; });
    };
    var ready = function () {
      var v = variant();
      if (!v.available || missingPhotos().length) return false;
      if (state.style.text === 'required' && !el.t1.value.trim()) return false;
      return !Object.keys(state.shr || {}).some(function (k) { return state.shr[k]; });
    };
    // hidden until the design is complete, greyed with progress while the photo saves, then live
    var lock = function (on, msg, hide) { if (!wal) return; wal.hidden = !!hide; wal.classList.toggle('is-locked', !!on); wal.classList.remove('is-busy'); walNote.textContent = msg || ''; };
    sync = { keys: [], urls: {}, sig: null, busy: null, timer: null };
    var runSync = function () {
      if (!wal) return Promise.resolve();
      if (sync.busy) return sync.busy;
      if (!ready()) { lock(true, '', true); return Promise.resolve(); }
      if (sync.sig === sigOf() && sync.keys.length) { lock(false); return Promise.resolve(); }
      wal.hidden = false; wal.classList.add('is-locked', 'is-busy'); walNote.textContent = '';
      sync.busy = putInCart(function (pc) { walNote.textContent = 'Saving your photo for express checkout… ' + (pc || 0) + '%'; }).then(function () {
        sync.busy = null; lock(false);
        if (sync.sig !== sigOf()) scheduleSync(150);
      }).catch(function () { sync.busy = null; lock(true, '', true); });
      return sync.busy;
    };
    function scheduleSync(ms) {
      if (!sync || !wal) return;
      if (!wal.classList.contains('is-locked') && sync.sig !== null && sync.sig !== sigOf()) wal.classList.add('is-busy');
      clearTimeout(sync.timer); sync.timer = setTimeout(runSync, ms == null ? 120 : ms);
    }
    el.form.addEventListener('input', function (e) { var t = e.target; if (t && (t.tagName === 'TEXTAREA' || (t.tagName === 'INPUT' && /^(text|search)$/.test(t.type)))) scheduleSync(700); });

    el.form.addEventListener('submit', function (e) {
      e.preventDefault(); el.err.textContent = '';
      var s = state.style;
      if (s.text === 'required' && !el.t1.value.trim()) { el.err.textContent = 'Please add the name for your ' + NOUN + '.'; step('text').scrollIntoView({ behavior: 'smooth', block: 'center' }); el.t1.focus(); return; }
      var miss = missingPhotos();
      if (miss.length) {
        miss[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        miss[0].classList.add('is-need'); setTimeout(function () { miss[0].classList.remove('is-need'); }, 1600);
        setTimeout(function () { $('[data-cst-file]', miss[0]).click(); }, 450);
        return;
      }
      var label0 = el.cta.textContent;
      el.cta.disabled = true; el.cta.textContent = state.qty > 1 ? 'Uploading photos…' : 'Adding to cart…';
      clearTimeout(sync.timer);
      (sync.busy || Promise.resolve()).catch(function () {}).then(function () {
        if (sync.keys.length && sync.sig === sigOf()) return;   // already in the cart from express sync
        return putInCart();
      }).then(function () {
        track('add_to_cart');
        try { sessionStorage.removeItem('cst'); } catch (er) {}
        window.location.href = root_url + 'cart';
      }).catch(function (ex) {
        el.cta.disabled = false; el.cta.textContent = label0;
        el.err.textContent = ex.message + ' Please try again.';
      });
    });

    // ---------- pet-aware heading
    var h = $('[data-cst-pettext]');
    if (h && (petQ === 'dog' || petQ === 'cat')) { var t = h.getAttribute('data-' + petQ); if (t) h.textContent = t; }

    // ---------- pick from cards elsewhere on the page
    root.__pick = function (alias, pet) {
      if (pet === 'dog' || pet === 'cat') { state.pet = pet; setPetWords(); }
      var f = findStyle(alias); if (f) state.style = f;
      applyStyle(); track('pick');
      $('#build').scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    // ---------- start
    setPetWords();
    applyStyle();
  }
  var start = function () { document.querySelectorAll('[data-cst]').forEach(init); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-cst-pick]'); if (!a) return;
    var r = document.querySelector('[data-cst]'); if (!r || !r.__pick) return;
    e.preventDefault(); r.__pick(a.getAttribute('data-cst-pick'), a.getAttribute('data-cst-pet'));
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#build"]'); if (!a || a.hasAttribute('data-cst-pick')) return;
    var t = document.getElementById('build'); if (!t) return;
    e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
})();
